import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import UA from 'drip/ua';
import KNB from '@dp/knb';
import Drip from 'drip';
import compareVersions from '@/utils/compareVersions';
// knb方法内的console保留方便排查线上问题
export function notifyCalendar(obj) {
  if (obj.start) {
    obj.start = Number(obj.start);
  }
  if ((obj.start && obj.start - Date.now()) > 10 * 60 * 1000) {
    if (Drip.UA.IS_MAOYAN && compareVersions(Drip.UA.appVersion, '9.76.0')) {
      return new Promise(function (resolve) {
        KNB.use('movie.addCustomCalendar', {
          params: {
            eventUnionId: obj.eventUnionId,
            sceneToken: 'my-87bff41fea170162',
            startTime: obj.start / 1000,
            endTime: obj.endTime / 1000,
            title: obj.title,
            alarm: true,
            location: obj.location,
            alarmOffsets: obj.alarmOffsets,
            calendarTitle: '猫眼'
          },
          success: function success() {
            resolve(true);
          },
          fail: function fail(error) {
            _Toast('添加失败，请在手机【设置】中打开日历提醒权限');
            resolve(false);
          }
        });
      });
    } else {
      return new Promise(function (resolve) {
        KNB.setupEvent({
          sceneToken: 'my-87bff41fea170162',
          title: obj.title,
          //String 类型，日历标题
          start: obj.start,
          //Number 类型, 开始时间， 毫秒时间戳
          duration: 60,
          //Number 类型，持续时间，单位秒，默认时间 1.5h
          alarm: -600,
          //Number 类型，自开始时间起过多少秒的闹铃，可填负数，表明提前 start 的闹铃时间
          success: function success() {
            resolve(true);
          },
          fail: function fail(e) {
            resolve(false);
          }
        });
      });
    }
  } else {
    return false;
  }
}
export function notifyCalendarNew(obj) {
  try {
    if (obj.start) {
      obj.start = Number(obj.start);
    }
    if ((obj.start && obj.start - Date.now()) > 10 * 60 * 1000) {
      if (Drip.UA.IS_MAOYAN && compareVersions(Drip.UA.appVersion, '9.80.0')) {
        return new Promise(function (resolve) {
          KNB.use('movie.addCustomCalendar', {
            params: {
              eventUnionId: obj.eventUnionId,
              sceneToken: 'my-87bff41fea170162',
              startTime: Math.floor(obj.start / 1000),
              endTime: Math.floor(obj.endTime / 1000),
              title: obj.title,
              alarm: true,
              location: obj.location,
              alarmOffsets: obj.alarmOffsets,
              calendarTitle: '猫眼'
            },
            success: function success(res) {
              var _res$data;
              resolve({
                status: true,
                eventId: res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.eventId
              });
            },
            fail: function fail(error) {
              if (Drip.UA.osName === 'ios' && error && error.errorCode === '-1000') {
                resolve({
                  status: false,
                  eventId: null,
                  type: 'noPermission'
                });
              } else if (Drip.UA.osName === 'android' && error && error.errorCode === -2) {
                resolve({
                  status: false,
                  eventId: null
                });
              } else {
                _Toast('提醒设置失败 请稍后再试');
                resolve({
                  status: false,
                  eventId: null
                });
              }
            }
          });
        });
      }
    } else {
      return new Promise(function (resolve) {
        resolve({
          status: false,
          eventId: null
        });
      });
    }
  } catch (error) {
    return new Promise(function (resolve) {
      resolve({
        status: false,
        eventId: null
      });
    });
  }
}
export function queryCalendar(obj) {
  try {
    var _Drip$UA, _Drip$UA2;
    var params = {
      sceneToken: 'my-87bff41fea170162'
    };
    if (((_Drip$UA = Drip.UA) === null || _Drip$UA === void 0 ? void 0 : _Drip$UA.osName) === 'ios') {
      params.startTime = obj === null || obj === void 0 ? void 0 : obj.startTime;
      params.endTime = obj === null || obj === void 0 ? void 0 : obj.endTime;
      params.title = obj === null || obj === void 0 ? void 0 : obj.title;
      params.calendarTitle = obj === null || obj === void 0 ? void 0 : obj.calendarTitle;
    }
    if (((_Drip$UA2 = Drip.UA) === null || _Drip$UA2 === void 0 ? void 0 : _Drip$UA2.osName) === 'android') {
      params.eventUnionId = obj.eventUnionId;
    }
    return new Promise(function (resolve) {
      KNB.use('movie.isCalendarEventExist', {
        params: params,
        success: function success(res) {
          var _Drip$UA3, _res$data2, _res$data3, _res$data3$events, _Drip$UA4;
          if (((_Drip$UA3 = Drip.UA) === null || _Drip$UA3 === void 0 ? void 0 : _Drip$UA3.osName) === 'ios' && res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.status && (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$events = _res$data3.events) === null || _res$data3$events === void 0 ? void 0 : _res$data3$events.length) > 0 || ((_Drip$UA4 = Drip.UA) === null || _Drip$UA4 === void 0 ? void 0 : _Drip$UA4.osName) === 'android' && res !== null && res !== void 0 && res.data) {
            var _res$data4;
            resolve({
              status: true,
              events: ((res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.events) || []).filter(function (item) {
                return item && String(item === null || item === void 0 ? void 0 : item.startTime) === String(obj === null || obj === void 0 ? void 0 : obj.startTime) && String(item === null || item === void 0 ? void 0 : item.endTime) === String(obj === null || obj === void 0 ? void 0 : obj.endTime);
              })
            });
          } else {
            resolve({
              status: false
            });
          }
        },
        fail: function fail() {
          resolve({
            status: false
          });
        }
      });
    });
  } catch (error) {
    return Promise.resolve({
      status: false
    });
  }
}
export function removeCalendar(obj) {
  try {
    var _Drip$UA5, _obj$calendarEventIos, _Drip$UA6, _Drip$UA7, _obj$calendarEventIos2, _Drip$UA8;
    if (((_Drip$UA5 = Drip.UA) === null || _Drip$UA5 === void 0 ? void 0 : _Drip$UA5.osName) === 'ios' && !((_obj$calendarEventIos = obj.calendarEventIosList) !== null && _obj$calendarEventIos !== void 0 && _obj$calendarEventIos.length)) return Promise.resolve({
      status: false
    });
    if (((_Drip$UA6 = Drip.UA) === null || _Drip$UA6 === void 0 ? void 0 : _Drip$UA6.osName) === 'android' && !obj.eventUnionId) return Promise.resolve({
      status: false
    });
    var params = {
      sceneToken: 'my-87bff41fea170162'
    };
    if (((_Drip$UA7 = Drip.UA) === null || _Drip$UA7 === void 0 ? void 0 : _Drip$UA7.osName) === 'ios') params.eventId = (_obj$calendarEventIos2 = obj.calendarEventIosList) === null || _obj$calendarEventIos2 === void 0 ? void 0 : _obj$calendarEventIos2.map(function (item) {
      return item === null || item === void 0 ? void 0 : item.eventId;
    });
    if (((_Drip$UA8 = Drip.UA) === null || _Drip$UA8 === void 0 ? void 0 : _Drip$UA8.osName) === 'android') params.eventUnionId = obj.eventUnionId;
    return new Promise(function (resolve) {
      KNB.use('movie.removeCalendarEvent', {
        params: params,
        success: function success(res) {
          var _Drip$UA9, _res$data5, _Drip$UA10;
          if (((_Drip$UA9 = Drip.UA) === null || _Drip$UA9 === void 0 ? void 0 : _Drip$UA9.osName) === 'ios' && res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.status || ((_Drip$UA10 = Drip.UA) === null || _Drip$UA10 === void 0 ? void 0 : _Drip$UA10.osName) === 'android' && res !== null && res !== void 0 && res.data) {
            _Toast('取消提醒成功');
            resolve({
              status: true
            });
          } else {
            _Toast('提醒设置失败 请稍后再试');
            resolve({
              status: false
            });
          }
        },
        fail: function fail(error) {
          var _Drip$UA11, _Drip$UA12;
          if (((_Drip$UA11 = Drip.UA) === null || _Drip$UA11 === void 0 ? void 0 : _Drip$UA11.osName) === 'ios' && (error === null || error === void 0 ? void 0 : error.errorCode) === '-1000' || ((_Drip$UA12 = Drip.UA) === null || _Drip$UA12 === void 0 ? void 0 : _Drip$UA12.osName) === 'android' && (error === null || error === void 0 ? void 0 : error.errorCode) === -2) {
            _Toast('取消提醒失败，请在手机【设置】中打开日历提醒权限');
            resolve({
              status: false,
              type: 'noPermission'
            });
          } else {
            _Toast('提醒设置失败 请稍后再试');
            resolve({
              status: false
            });
          }
        }
      });
    });
  } catch (error) {
    return Promise.resolve({
      status: false
    });
  }
}
export function removeCalendarByParams(obj) {
  return new Promise(function (resolve) {
    try {
      var _Drip$UA13, _Drip$UA14, _Drip$UA15;
      if (!((_Drip$UA13 = Drip.UA) !== null && _Drip$UA13 !== void 0 && _Drip$UA13.IS_MAOYAN && compareVersions((_Drip$UA14 = Drip.UA) === null || _Drip$UA14 === void 0 ? void 0 : _Drip$UA14.appVersion, '9.80.0'))) {
        resolve({
          status: false
        });
        return;
      }
      var params = {
        sceneToken: 'my-87bff41fea170162'
      };
      if (((_Drip$UA15 = Drip.UA) === null || _Drip$UA15 === void 0 ? void 0 : _Drip$UA15.osName) === 'ios') {
        params.startTime = obj === null || obj === void 0 ? void 0 : obj.startTime;
        params.endTime = obj === null || obj === void 0 ? void 0 : obj.endTime;
        params.title = obj === null || obj === void 0 ? void 0 : obj.title;
        params.calendarTitle = obj === null || obj === void 0 ? void 0 : obj.calendarTitle;
        KNB.use('movie.isCalendarEventExist', {
          params: params,
          success: function success(res) {
            var _res$data6, _res$data6$events;
            if ((res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : (_res$data6$events = _res$data6.events) === null || _res$data6$events === void 0 ? void 0 : _res$data6$events.length) > 0) {
              var _res$data7;
              var eventList = ((res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.events) || []).filter(function (item) {
                return item && String(item === null || item === void 0 ? void 0 : item.startTime) === String(obj === null || obj === void 0 ? void 0 : obj.startTime) && String(item === null || item === void 0 ? void 0 : item.endTime) === String(obj === null || obj === void 0 ? void 0 : obj.endTime);
              });
              if (eventList.length === 0) {
                resolve({
                  status: true
                });
                return;
              }
              var removeParams = {
                sceneToken: 'my-87bff41fea170162',
                eventId: eventList.map(function (item) {
                  return item === null || item === void 0 ? void 0 : item.eventId;
                })
              };
              KNB.use('movie.removeCalendarEvent', {
                params: removeParams,
                success: function success(res) {
                  resolve({
                    status: true
                  });
                },
                fail: function fail(error) {
                  resolve({
                    status: false
                  });
                }
              });
            } else {
              resolve({
                status: false
              });
            }
          },
          fail: function fail() {
            resolve({
              status: false
            });
          }
        });
      } else {
        params.eventUnionId = obj.eventUnionId;
        KNB.use('movie.isCalendarEventExist', {
          params: params,
          success: function success(res) {
            if (res !== null && res !== void 0 && res.data) {
              KNB.use('movie.removeCalendarEvent', {
                params: params,
                success: function success(res) {
                  resolve({
                    status: true
                  });
                },
                fail: function fail(error) {
                  resolve({
                    status: false
                  });
                }
              });
            } else {
              resolve({
                status: false
              });
            }
          },
          fail: function fail() {
            resolve({
              status: false
            });
          }
        });
      }
    } catch (error) {
      return resolve({
        status: false
      });
    }
  });
}